import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LearnerAuthProvider } from './contexts/LearnerAuthContext';
import HeaderUserMenu from './components/auth/HeaderUserMenu';
import FeedbackButton from './components/feedback/FeedbackButton';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { initTelemetry, trackError } from './services/telemetryService';

// ── Telemetry bootstrap ──────────────────────────────────────────────────────
// Fire-and-forget. Emits 'app_open' and wires the app-session-end flush.
initTelemetry();

// Global technical-health capture: uncaught errors + unhandled promise
// rejections feed trackError. Both are best-effort and never block.
//
// `filename` is the ErrorEvent's offending script URL. It is passed so
// isExtensionScriptError() can tell an injected extension script from our own
// code; it is NOT an allow-listed metadata key, so sanitizeMetadata strips it
// before anything reaches telemetry_events. No URL is ever stored.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    trackError((e && (e.error || e.message)) || 'window.error', {
      code: 'window.onerror',
      filename: (e && e.filename) || undefined,
    });
  });
  window.addEventListener('unhandledrejection', (e) => {
    trackError((e && e.reason) || 'unhandledrejection', { code: 'unhandledrejection' });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <LearnerAuthProvider>
        <App />
        <HeaderUserMenu />
        <FeedbackButton />
      </LearnerAuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
